import { Helmet } from 'react-helmet-async'

export default function NotFound() {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>Page Not Found - P5 AI Studio</title>
      </Helmet>
      <div className="flex items-center justify-center h-screen bg-ide-bg text-ide-text">
        <div className="text-center p-8">
          <h1 className="text-6xl font-bold text-ide-accent mb-4">404</h1>
          <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
          <p className="text-ide-textMuted mb-8 max-w-md">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex gap-4 justify-center">
            <a 
              href="/" 
              className="px-6 py-3 bg-ide-accent text-white rounded-lg hover:bg-ide-accent/80 transition-colors"
            >
              Go to IDE
            </a>
            <a 
              href="/gallery/" 
              className="px-6 py-3 bg-ide-panel border border-ide-border text-ide-text rounded-lg hover:bg-ide-hover transition-colors"
            >
              Browse Gallery
            </a>
          </div>
        </div>
      </div>
    </>
  )
}
